<template>
  <div class="check-item">
    <div class="row">
      <div class="col-sm-7">{{ i18n.videoPlayer }}</div>
      <div class="col-sm-3"></div>
      <div class="col-sm-2">
        <checker-status :result="result.value"></checker-status>
      </div>
    </div>
    <div class="row video-player" v-show="!closed">
      <div class="col-sm-12">
        <div v-show="!playerReady" class="init-holder">{{ i18n.videoPlayerInit }}</div>
        <div v-show="playerReady">
          <video id="testVideo" class="video-js vjs-default-skin vjs-big-play-centered" controls preload="auto" width="700" height="393"
               poster="http://virtualdestinations.6connex.com/upload/files/6connex/sync-test.png" data-setup="{}">
            <source src="http://virtualdestinations.6connex.com/upload/files/6connex/sync-test.mp4" type="video/mp4">
            <source src="http://virtualdestinations.6connex.com/upload/files/6connex/sync-test.webm" type="video/webm">
          </video>
        </div>
        <div class="alert alert-danger" v-if="result.error !== ''">{{ result.error }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import log from 'loglevel'
import CheckerStatus from './CheckerStatus'
import videojs from 'video.js'

const checkerName = 'video-player'

export default {
  name: checkerName,
  data () {
    return {
      status: 'in-progress',
      result: {
        value: '',
        error: ''
      },
      i18n: window.SYSTEM_CHECK.i18n,
      playerReady: false,
      closed: false
    }
  },
  methods: {
    closePlayer (player) {
      player.dispose()
      this.closed = true
    }
  },
  components: {
    CheckerStatus
  },
  created () {
    this.$emit('initialized', {name: checkerName})
  },
  mounted () {
    var vm = this
    try {
      videojs('testVideo').ready(function () {
        var player = this
        player.volume(0.1)
        /* player.muted(true) */

        setTimeout(() => {
          player.play()
          vm.playerReady = true
        }, 1500)

        player.on('ended', function () {
          vm.result.value = 'passed'
          vm.$emit('completed', {name: checkerName, result: 'passed'})
          vm.closePlayer(player)
        })

        player.on('error', function () {
          log.error('Player error', player.error())
          vm.result.value = 'failed'
          vm.$emit('completed', {name: checkerName, result: 'Failed. Error: ' + player.error().message})
        })
      })
    } catch (err) {
      vm.result.value = 'failed'
      var errorDetail = JSON.stringify(err)
      vm.result.error = 'Fail to initialize Video Player. Error detail: ' + errorDetail
      vm.$emit('completed', {name: checkerName, result: 'Failed. Error: ' + errorDetail})
    }
  }
}
</script>

<style scoped>
  .video-player {
    margin-top: 10px;
  }

  .video-player .video-js {
    text-align: center;
  }

  .init-holder {
    width: 700px;
    height: 394px;
    background: #f4f4f4;
    border: 1px solid #ddd;
    text-align: center;
    line-height: 393px;
    color: #666;
  }

  .video-player .panel {
    margin-bottom: 10px;
  }

  .video-player .panel .btn {
    margin-right: 10px;
  }
</style>
